import React from "react";
import { Link } from "react-router-dom";
import clsx from "clsx";

import LogoImg from "../../../assets/images/logo.png";
import { loginPath } from "../../../teacherStore";
import { emailRegex } from "../../../constants/regex";

import styles from "./ForgotPassword.module.scss";

export interface ForgotPasswordProps {
  error: string;
  forgotPassword: (email: string) => void;
}

const validates: { [key: string]: (value: any) => string } = {};

validates["email"] = val => {
  return !val.email.trim()
    ? "この項目は入力が必須です。"
    : val.email.match(emailRegex)
    ? ""
    : "正しいメールアドレスを入力してください。";
};

export const LoginForm = (props: ForgotPasswordProps) => {
  const [state, setState] = React.useState({
    email: "",
    isSubmitted: false,
    errorMessages: {} as { [key: string]: string },
  });

  const onSubmit = React.useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      const errorMessages = {} as { [key: string]: string };
      Object.keys(validates).forEach(key => {
        const ret = validates[key](state);
        if (ret) {
          errorMessages[key] = ret;
        }
      });
      if (Object.keys(errorMessages).length > 0) {
        setState(s => ({ ...s, errorMessages }));
        return;
      }
      props.forgotPassword(state.email);
    },
    [props, state],
  );

  const onChange = React.useCallback(
    (e: React.SyntheticEvent<HTMLInputElement>) => {
      e.preventDefault();
      const val = e.currentTarget.value;
      const key = e.currentTarget.name;
      const args = { [key]: val };
      const ret = validates[key](args);
      setState(prevState => ({
        ...prevState,
        [key]: val,
        errorMessages: { ...prevState.errorMessages, [key]: ret },
      }));
    },
    [],
  );

  return (
    <div className="d-flex">
      <div className={styles.content}>
        <p className={styles.logo}>
          <img src={LogoImg} alt="brand logo" />
        </p>
        <div className={styles.wrapper}>
          <h3 className={styles.title}>パスワードリセット</h3>
          <h4 className={styles.subTitle}>
            <p>以下のフォームにご登録のメールアドレスを入力してください。</p>
            <p>
              入力したメールアドレス宛にパスワードリセット用のメールが送信されます。
            </p>
          </h4>
          <form onSubmit={onSubmit}>
            {props.error && (
              <div className={styles.errorMessage}>{props.error}</div>
            )}
            <div className={styles.field}>
              <label htmlFor="email">Email</label>
              <div
                className={clsx(
                  styles.wrapInput,
                  state.errorMessages["email"] && styles.errorInput,
                )}
              >
                <input
                  type="email"
                  name="email"
                  className={
                    state.errorMessages["email"]
                      ? "is-invalid"
                      : state.email
                      ? "is-valid"
                      : ""
                  }
                  id="email"
                  value={state.email}
                  onChange={onChange}
                  onBlur={onChange}
                />
              </div>
              <div className={styles.error}>{state.errorMessages["email"]}</div>
            </div>
            <button
              className={styles.btnSubmit}
              onClick={onSubmit}
              disabled={
                Object.keys(state.errorMessages).filter(
                  k => state.errorMessages[k],
                ).length > 0
              }
            >
              送信
            </button>
            <div className={styles.forgotPasswordLink}>
              <Link to={loginPath} className={styles.forgotPassword}>
                ログイン画面に戻る
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
